import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './TableCellSubdomainActions.css';
import Icon, { IconTypes } from '../../../../components/foundations/Icon';
import Button from '../../../../components/atoms/Button';
import Tooltip from '../../../../components/molecules/Tooltip';

const translationPrefix = 'STATIC.PAGES.MANAGE_LINKS';

const TableCellSubdomainActions = props => {
    const { tdClassName, rowIndex, row, onCreateCancelClick, onArchiveClick, onFavouriteClick, onCreateClick } = props;
    const { isFavourite, isCreatingDomain, isRowDisabled, isCreatingButtonDisabled, isLoading } = row;
    return (
        <td className={classNames(tdClassName, isCreatingDomain ? css.backgroundCreate : '')}>
            {!isCreatingDomain || rowIndex > 0 ? (
                <div className={css.actionsContainer}>
                    {isFavourite ? (
                        <Icon onClick={() => onFavouriteClick(row)} className={css.active} name="star-off" />
                    ) : (
                        <Tooltip titleTranslationKey={`${translationPrefix}.DEFAULT_TOOLTIP`}>
                            <Icon onClick={() => onFavouriteClick(row)} className={css.notActive} name="star" />
                        </Tooltip>
                    )}
                    <Tooltip titleTranslationKey={`${translationPrefix}.ARCHIVE_TOOLTIP`}>
                        <Icon onClick={() => onArchiveClick(row)} className={css.notActive} name="archive" />
                    </Tooltip>
                </div>
            ) : (
                <div className={css.createContainer}>
                    <Button
                        showSpinner={isLoading}
                        disabled={isCreatingButtonDisabled || isRowDisabled}
                        onClick={onCreateClick}
                        type="secondary"
                    >
                        <Translate id={`${translationPrefix}.SUB_DOMAIN.TABLE.CREATE`} />
                    </Button>
                    <Icon onClick={onCreateCancelClick} name="close-fill" type={IconTypes.MINGCUTE} />
                </div>
            )}
        </td>
    );
};

TableCellSubdomainActions.propTypes = {
    row: PropTypes.object,
    tdClassName: PropTypes.string,
    rowIndex: PropTypes.number,
    onCreateClick: PropTypes.func,
    onArchiveClick: PropTypes.func,
    onCreateCancelClick: PropTypes.func,
    onFavouriteClick: PropTypes.func,
    subDomainsPageData: PropTypes.objectOf({ working: PropTypes.bool }),
};

export default TableCellSubdomainActions;
